import classNames from "classnames";
import { useCallback, useState } from "react";
import s from './homework-submission-card.module.scss'
import { useApproveHomework } from '@widgets/appointment/api/useApproveHomework';
import { useRejectHomework } from '@widgets/appointment/api/useRejectHomework';
import { getFullName } from '@utils/lib/getFullname';
import { AppointmentContentBlock } from '../appointment-content-block/appointment-content-block';
import { CommentCard } from '../homework-comment-card/homework-comment-card';
import { MaterialComposer } from '../material-composer/material-composer';

export const SubmissionCard = ({ submission, appointment, homework }) => {
  const [isCommentShown, setIsCommentShown] = useState(false);

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  const { mutate: approve } = useApproveHomework(appointment?.id);
  const { mutate: reject } = useRejectHomework(appointment?.id, () => {
		setIsCommentShown(false)
	});

  const submitData = {
    appointmentId: appointment.id,
    homeworkId: homework.id,
    submissionId: submission.id,
  };


  const onReject = useCallback(
    ({ text }) =>
      reject({
        appointmentId: appointment.id,
        homeworkId: homework.id,
        submissionId: submission.id,
        comment: text,
      }),
    [appointment.id, homework.id, reject, submission.id]
  );


  return (
    <>
      <div className={s.submissionCard}>
        <div className={s.contentBlock}>
          <div className={s.submissionHeader}>
            <div className={s.jcsb}>
              <span className={s.date}>{formatDate(submission.created_at)}</span>
              {isCommentShown ? null : submission.status !== "created" ? (
                <span className={classNames(s.status, s[submission.status])}>
                  {
                    {
                      rejected: "Отклонено",
                      approved: "Принято",
                    }[submission.status]
                  }
                </span>
              ) : (
                <div className={s.btns}>
                  <button
                    className={s.decline}
                    onClick={() => setIsCommentShown(true)}
                  >
                    Отклонить
                  </button>
                  <button
                    className={s.approve}
                    onClick={() => approve(submitData)}
                  >
                    Принять
                  </button>
                </div>
              )}
            </div>
            <div className={s.author}>
              <div className={s.avatar}>
                <img
                  src={
                    appointment?.student?.avatar
                      ? process.env.REACT_APP_STORAGE_URL +
                        appointment?.student?.avatar.image
                      : process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
                  }
                  alt=""
                />
              </div>
              <div className={s.content}>
                <h5 className={s.name}>
                  {getFullName(appointment?.student)}
                </h5>
                <span className={s.role}>ученик</span>
              </div>
            </div>
          </div>

          <AppointmentContentBlock attachments={submission?.attachments} text={submission.text}/>
          
          {isCommentShown ? (
            <MaterialComposer
                startExpanded
                submitLabel="Отправить"
                initialText=""
                onSubmit={onReject}
                onCancel={() => setIsCommentShown(false)}
                showAudio={false}
                showAttachmentButton={false}
                showCollapseButton={false}
              />
          ) : null}
        </div>
      </div>
			{submission?.comment ? <CommentCard {...{submission, appointment}}/> : null}
    </>
  );
};

// export const SubmissionCard = ({ submission, appointment, homework }) => {
//   const [isCommentShown, setIsCommentShown] = useState(false);

//   function formatDate(dateString) {
//     const date = new Date(dateString);

//     const day = date.getDate().toString().padStart(2, "0");
//     const month = (date.getMonth() + 1).toString().padStart(2, "0");
//     const year = date.getFullYear();
//     const hours = date.getHours().toString().padStart(2, "0");
//     const minutes = date.getMinutes().toString().padStart(2, "0");

//     return `${day}.${month}.${year} ${hours}:${minutes}`;
//   }

//   const { mutate: approve } = useApproveHomework(appointment?.id);
//   const { mutate: reject } = useRejectHomework(appointment?.id, () => {
// 		setIsCommentShown(false)
// 	});

//   const submitData = {
//     appointmentId: appointment.id,
//     homeworkId: homework.id,
//     submissionId: submission.id,
//   };

//   const onReject = useCallback(
//     ({ text }) =>
//       reject({
//         appointmentId: appointment.id,
//         homeworkId: homework.id,
//         submissionId: submission.id,
//         comment: text,
//       }),
//     [appointment.id, homework.id, reject, submission.id]
//   );

//   return (
//     <>
//       <div className={s.submissionCard}>
//         <div className={s.contentBlock}>
//           <div className={s.submissionHeader}>
//             <div className={s.jcsb}>
//               <span className={s.date}>{formatDate(submission.created_at)}</span>
//               {isCommentShown ? null : submission.status !== "created" ? (
//                 <span className={classNames(s.status, s[submission.status])}>
//                   {
//                     {
//                       rejected: "Отклонено",
//                       approved: "Принято",
//                     }[submission.status]
//                   }
//                 </span>
//               ) : canManageHomework ? (
//                 <div className={s.menuWrapper} ref={menuRef}>
//                   <button
//                     className={s.menuButton}
//                     type="button"
//                     aria-label="Действия с ответом"
//                     onClick={() => setIsMenuOpen((prev) => !prev)}
//                   >
//                     <IconDots size={20} />
//                   </button>
//                   {/* {isMenuOpen ? (
//                     <div className={s.menu}>
//                       <button
//                         className={`${s.menuItem} ${s.dangerItem}`}
//                         type="button"
//                         onClick={() => {
//                           setIsMenuOpen(false);
//                           setIsCommentShown(true);
//                         }}
//                       >
//                         Отклонить
//                       </button>
//                       <button
//                         className={s.menuItem}
//                         type="button"
//                         onClick={() => {
//                           setIsMenuOpen(false);
//                           approve(submitData);
//                         }}
//                       >
//                         Принять
//                       </button>
//                     </div>
//                   ) : null} */}
//                 </div>
//               ) : (
//                 <span className={classNames(s.status, s.created)}>
//                   Ожидает ответа
//                 </span>
//               )}
//             </div>
//             <div className={s.author}>
//               <div className={s.avatar}>
//                 <img
//                   src={
//                     appointment?.student?.avatar
//                       ? process.env.REACT_APP_STORAGE_URL +
//                         appointment?.student?.avatar.image
//                       : process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
//                   }
//                   alt=""
//                 />
//               </div>
//               <div className={s.content}>
//                 <h5 className={s.name}>
//                   {getFullName(appointment?.student)}
//                 </h5>
//                 <span className={s.role}>ученик</span>
//               </div>
//             </div>
//           </div>

//           <AppointmentContentBlock attachments={submission?.attachments} text={submission.text}/>

//           {isCommentShown && canManageHomework ? (
//             <div className={s.commentBlock}>
//               <MaterialComposer
//                 startExpanded
//                 submitLabel="Отправить"
//                 initialText=""
//                 onSubmit={onReject}
//                 onCancel={() => setIsCommentShown(false)}
//                 showAudio={false}
//                 showAttachmentButton={false}
//                 showCollapseButton={false}
//               />
//             </div>
//           ) : null}
//         </div>
//       </div>
// 			{submission?.comment ? <CommentCard {...{submission, appointment}}/> : null}
//     </>
//   );
// };
